import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/data/defaults";

const ContentContext = createContext(null);
export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent({ ...DEFAULT_CONTENT, ...data });
    } catch {
      /* fall back to defaults */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, setContent, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}
